import RequestAPI from '../index'
import getConfig from 'Config/config'

const apiServer = new RequestAPI(getConfig().apiServer)
export const apiMockupServer = new RequestAPI(getConfig().apiMockupServer)
export default apiServer
